// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"13":"0c0383e8","77":"6af33e8b","286":"d683e662","380":"c74997df"}[chunkId] + ".chunk.css";
};